import React from 'react';
import { useTranslation } from 'react-i18next';

const CrashComponent = ({ report, beta }) => {
  const { t } = useTranslation();

  if (!report.crash_types || report.crash_types.length === 0) {
    return null;
  }

  return (
    <div className="further-details">
      {beta && <div className="border-b my-4 border-[#F4F5F7]" />}
      <h2>Further Details</h2>
      <table>
        <tbody>
          <tr>
            <th>Crash Type</th>
            <td>
              {report.crash_types.map((w) => t(`hazard.crash.${w.toLowerCase()}`)).join(', ')}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CrashComponent;
